import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';

import NavigationRouter from '@artsman/react-router-nav';

const NAV_GROUP_OPENED_ICON = (
  <span><FontAwesome name="caret-square-o-down" /></span>
);

const NAV_GROUP_CLOSED_ICON = (
  <span><FontAwesome name="caret-square-o-right" /></span>
);
export default class Nav extends PureComponent {
  static propTypes = {
    responsive: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
  }

  onBrandItemLinkClick = (path) => {
    const { onBrandItemLinkClick } = this.props;
    if (onBrandItemLinkClick) {
      return onBrandItemLinkClick(path);
    }
    return false; // prevent link from being transitioned to
  }

  render() {
    const { responsive, ...otherProps } = this.props;

    const navProps = {
      ...otherProps,
      inverse: true,
      groupOpenedIcon: NAV_GROUP_OPENED_ICON,
      groupClosedIcon: NAV_GROUP_CLOSED_ICON,
      collapsed: responsive.lessThan.large,
      onBrandItemLinkClick: this.onBrandItemLinkClick
    };

    return (
      <NavigationRouter {...navProps}/>
    )
  }
}
